import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ImageIcon from '@material-ui/icons/Image';

const useStyles = makeStyles(theme => ({
  mediaPlaceholder: {
    height: 150,
    background: theme.palette.grey[50],
    padding: 0
  },
  createBoxRoot: {
    height: '100%',
    textAlign: 'center'
  },
  icon: {
    color: theme.palette.grey[500]
  },
  text: {
    padding: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

const ImageMissingPlaceholder = ({ className }) => {
  const classes = useStyles();
  return (
    <div className={cx(classes.mediaPlaceholder, className)}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        className={classes.createBoxRoot}
      >
        <ImageIcon fontSize="large" classes={{ root: classes.icon }} />
        <Typography variant="subtitle2" classes={{ root: classes.text }}>
          <FormattedMessage id="media.missingImagePlaceholderLabel" />
        </Typography>
      </Box>
    </div>
  );
};

ImageMissingPlaceholder.propTypes = {
  className: PropTypes.string
};

export default ImageMissingPlaceholder;
